<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Rsbx0K/tc-custom/9781504060646.jpg?1728259422705" alt="This image is the cover for the book Arm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arm
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An ambitious gambler may lose it all in this novel by an Edgar Award–winning “superlative storyteller” (<i>Publishers Weekly</i>).</b></p><p>He was known as Cully the Arm—the best crapshooter in Chicago. Life was a game of both skill and luck, and he’d made his way to the big city seeking his chance to be a winner.</p><p>Before long he was moving between bars, backrooms, brothels—anywhere a man could gamble. Then he met a seductive woman named Lorry, who was playing a game of her own, and she wasn’t about to let any rules get in her way . . .</p> The inspiration for the film <i>The Big Town</i>, <i>The Arm</i> is a hard-edged crime novel that captures the gritty atmosphere of mid-twentieth-century Chicago as one man’s pursuit of a dream leads him into a nightmare.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clark Howard
      </h2>
      
      <p class="authorDescription body article">Clark Howard&#160;(1932-2016)&#160;Born in Ripley, Tennessee, Howard&#160;was one of the most honored mystery writers in America and was a longtime favorite of readers of Ellery Queen Mystery Magazine, Alfred Hitchcock Mystery Magazine, and numerous other publications. A professional writer for over 40 years, he wrote sixteen novels, six books of non-fiction, and published two collections of short stories, in addition to more than 200 uncollected short stories. Howard was honored with&#160;the Edgar Allan Poe award for best short story of 1981&#160;from the Mystery Writers of America. In 2009, Howard won the Edward D. Hoch Memorial Golden Derringer Award for Lifetime Achievement from the Short Fiction Mystery Society.&#8203;&#160;&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b2a00962